import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, count, countUnique, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface FullBodyPercentageProps {
    dateRange: { startDate: string; endDate: string };
}

export const FullBodyPercentage = ({ dateRange }: FullBodyPercentageProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_FULL_BODY_RATE_PER_LOCATION,
        params: { ...dateRange },
    });

    return (
        <BaseReport
            title={'Full Body % Rate per Location'}
            description={
                'This table shows you the rate at which each of your locations cuts Full Body coverage, along with their world rank and the global average for the entire date range selected above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: [
                    'Company Name',
                    'Reseller Name',
                    'Location Name',
                    'Successful Cuts',
                    'Full Body %',
                    'Rank',
                    'Global Avg',
                    'Global High Mark',
                ],
                data: data.map((item) => [
                    item.companyName,
                    item.resellerName,
                    item.locationName,
                    item.successfulCuts,
                    item.fullBodyRatePct,
                    item.rank,
                    item.globalAvg,
                    item.globalMax,
                ]),
                summaries: [countUnique, countUnique, countUnique, sum, average, count, average, average],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
